/**
 * Glastotaal logo — the official "GLASTOTAAL.NL" wordmark lockup.
 * Served from /public at a display-appropriate size (400px wide → crisp up to ~4×
 * DPR for the ~95px header lockup). webp with a small PNG fallback keeps it ~8 KB
 * instead of the 65 KB source. The full-res logo.png stays for e-mail/og:image.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <picture>
      <source srcSet="/logo.webp" type="image/webp" />
      <img
        src="/logo-sm.png"
        alt="Glastotaal"
        width={400}
        height={151}
        decoding="async"
        className={`w-auto ${className ?? "h-9"}`}
      />
    </picture>
  );
}
